import React from 'react'
import { useState } from 'react'
import exportFromJSON from "export-from-json"

import download from "../assets/download.png"
import defaultUser from "../assets/defaultUser.png"


function Transaction() {

    const [tx, setTx] = useState([])

    const data = tx
    const fileName = 'Transactions Data'
    const exportType = exportFromJSON.types.csv

    function downloadCSVfile() {
        exportFromJSON({ data, fileName, exportType })
    }


    return (
        <>
            <section className='transaction_sec'>
                <div className="container">
                    <div>
                        <h3>Transactions</h3>
                    </div>
                    <div className='table-responsive'>
                        <table className="table table-striped mt-5 text-center">
                            <thead>
                                <tr>
                                    <th scope="col">Energy Producer</th>
                                    <th scope="col">Transaction ID</th>
                                    <th scope="col">Transaction Status</th>
                                    <th scope="col">Transaction Type</th>
                                    <th scope="col">Quantity</th>
                                    <th scope="col">Price per kwh</th>
                                    <th scope="col">Total Transaction Amount</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">
                                        <button className='btn' onClick={() => downloadCSVfile()}>
                                            <img src={download} alt="image" className='img-fluid' />
                                        </button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <a href="#">
                                            <div className='d-flex ai-center'>
                                                <div>
                                                    <img src={defaultUser} alt="image" className='img-fluid me-2' style={{ width: "35px" }} />
                                                </div>
                                                <div>
                                                    User 1
                                                </div>
                                            </div>
                                        </a>
                                    </td>
                                    <th scope="row"># 1111</th>
                                    <td>
                                        <small className='success'>Success</small>
                                    </td>
                                    <td>Purchase</td>
                                    <td>100</td>
                                    <td>$ 500 (matic)</td>
                                    <td>$ 50000</td>
                                    <td>November 26, 2022</td>
                                    <td></td>
                                </tr>

                                <tr>
                                    <td>
                                        <a href="#">
                                            <div className='d-flex ai-center'>
                                                <div>
                                                    <img src={defaultUser} alt="image" className='img-fluid me-2' style={{ width: "35px" }} />
                                                </div>
                                                <div>
                                                    User 2
                                                </div>
                                            </div>
                                        </a>
                                    </td>
                                    <th scope="row"># 1222</th>
                                    <td>
                                        <small className='failed'>Failed</small>
                                    </td>
                                    <td>Sold</td>
                                    <td>50</td>
                                    <td>$ 100 (matic)</td>
                                    <td>$ 5000</td>
                                    <td>March 26, 2022</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Transaction
